<template>
  <div>
      <button @click="openPopup" class="btn btn-primary used-tags-btn">
          <i class="fa fa-search"></i>
          Used tags
      </button>
      <div v-if="showPopup" class="popup-overlay">
          <div class="popup-content">
              <div class="popup-header">
              </div>
              <div class="popup-body">
                  <div v-if="loading" class="text-center p-4">
                      Loading tags...
                  </div>
                  <div v-else-if="error" class="text-center p-4 text-danger">
                      {{ error }}
                  </div>
                  <div v-else>
                      <div class="label-object-tag-header">
                          <div class="tag-header-with-button">
                            <h2>{{ $dt('used_tags_popup.label_object_tags', 'Label Object Tags') }}
                            </h2>
                            <button @click="showPopup = false" class="close-btn">
                              <i class="fa fa-times"></i>
                            </button>
                          </div>
                          <div class="used-label-obj-tags">
                              <span v-for="tag in uniqueLabelObjectTags"
                                    :key="tag.id"
                                    class="badge badge-primary m-1">
                                  {{ tag.name }} {{ tag.label }}
                              </span>
                              <span v-if="!uniqueLabelObjectTags.length" class="text-muted">
                                  No label object tags found
                              </span>
                          </div>
                      </div>
                      <div class="sample-tag-header">
                          <h2>{{ $dt('used_tags_popup.sample_tags', 'Sample Tags') }}</h2>
                          <div class="used-sample-tags">
                              <span v-for="tag in uniqueSampleTags"
                                    :key="tag.id"
                                    class="badge badge-primary m-1">
                                  {{ tag.name }} {{ tag.label }}
                              </span>
                              <span v-if="!uniqueSampleTags.length" class="text-muted">
                                  No sample tags found
                              </span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Services from '@/services/index';

export default {
  name: 'UsedTagsPopup',
  props: {
    label_set_id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      showPopup: false,
      loading: false,
      error: null,
      labelObjectTags: [],
      sampleTags: []
    };
  },
  computed: {
    ...mapState('Auth', ['activeProjectId']),
    ...mapGetters('Tags', ['lookupTagById']),
    uniqueLabelObjectTags() {
      return Array.from(new Set(this.labelObjectTags)).map(tagId => {
        const tag = this.lookupTagById({ id: tagId});
        return {
          id: tagId,
          label: tag ? tag.label : 'unknown'
        };
      });
    },
    uniqueSampleTags() {
      return Array.from(new Set(this.sampleTags)).map(tagId => {
        const tag = this.lookupTagById({ id: tagId });
        return {
          id: tagId,
          label: tag ? tag.label : 'unknown'
        };
      });
    }
  },
  methods: {
    async fetchTags() {
      this.loading = true;
      this.error = null;

      try {
        const { data } = await Services.labelSets.sampleList(
          this.activeProjectId,
          this.label_set_id,
          {
            notpaginate: true,
            with_activities: true
          }
        );

        this.labelObjectTags = [];
        this.sampleTags = [];

        (data.data || []).forEach(sample => {
          if (sample.label_object_sets) {
            sample.label_object_sets.forEach(los => {
              if (los.label_objects) {
                los.label_objects.forEach(obj => {
                  if (obj.tags) {
                    obj.tags.forEach(tagId => {
                      if (typeof tagId === 'number') {
                        this.labelObjectTags.push(tagId);
                      } else if (tagId.id) {
                        this.labelObjectTags.push(tagId.id);
                      }
                    });
                  }
                });
              }
              if (los.tags) {
                los.tags.forEach(tagId => {
                  if (typeof tagId === 'number') {
                    this.labelObjectTags.push(tagId);
                  } else if (tagId.id) {
                    this.labelObjectTags.push(tagId.id);
                  }
                });
              }
            });
          }
          if (sample.tags) {
            sample.tags.forEach(tagId => {
              if (typeof tagId === 'number') {
                this.sampleTags.push(tagId);
              } else if (tagId.id) {
                this.sampleTags.push(tagId.id);
              }
            });
          }
        });

      } catch (err) {
        console.error('Error fetching tags:', err);
        this.error = 'Failed to load tags. Please try again.';
      } finally {
        this.loading = false;
      }
    },
    async openPopup() {
      this.showPopup = true;
      await this.fetchTags();
    },
    close() {
      this.showPopup = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.used-tags-btn {
  padding: 0 10px 0 10px;
}
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: white;
  border-radius: 4px;
  min-width: 300px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 1440px;
}

.popup-header {
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: end;
  align-items: center;
}

.label-object-tag-header, .sample-tag-header {
  h2 {
    background-color: #c8ced3;
    padding: 10px;
    font-size: 20px;
    margin-bottom: 0px;
    flex-grow: 1;
  }
}

.tag-header-with-button {
  display: flex;
}

.close-btn {
  background-color: #c8ced3;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  padding: 5px 10px;
  color: #666;
  justify-content: end;
}

.close-btn:hover {
  color: #333;
}

.used-label-obj-tags, .used-sample-tags {
  padding: 10px;
}

.badge {
  font-size: 0.9em;
  padding: 5px 10px;
}
</style>